import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { PureRadiobutton } from '../PureRadiobutton/PureRadiobutton';
import { CheckWithLabelBase } from '../internal/CheckWithLabelBase/CheckWithLabelBase';
export var Radio = forwardRef(function (props, ref) {
    return (React.createElement(CheckWithLabelBase, __assign({}, props, { ref: ref, CheckComponent: PureRadiobutton })));
});
//# sourceMappingURL=Radio.js.map